import { IRorResponseItem } from '@vivli/features/organizations/infrastructure/interface';

export function useRorHelpers() {
    const getRorName = (rorInfo: IRorResponseItem) => {
        return (
            rorInfo.names.find((n) => n.types.includes('ror_display'))?.value ??
            rorInfo.names.find((n) => n.types.includes('label') && n.lang === 'en')?.value ??
            rorInfo.names.find((n) => n.types.includes('label'))?.value
        );
    };

    const getRorWebsite = (rorInfo: IRorResponseItem) => {
        return rorInfo.links.find((n) => n.type === 'website')?.value;
    };

    return {
        getRorName,
        getRorWebsite,
    };
}
